import { render } from "./alert-message.html?vue&type=template&id=9901ce7e&scoped=true&ts=true"
import script from "./alert-message.vue?vue&type=script&lang=ts"
export * from "./alert-message.vue?vue&type=script&lang=ts"

import "./alert-message.scss?vue&type=style&index=0&id=9901ce7e&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9901ce7e"]])

export default __exports__